import * as React from 'react';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { IAuthContext } from 'models/common';

interface IProps {
	location: any;
	context: IAuthContext;
}

@connect(
	(store: IStore) => ({
		store,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
class DeactivateUserFinishedComponent extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public componentDidMount() {
		this.props.context.logoutDeactivatedUser();
	}

	public render() {
		return <div />;
	}
}

const DeactivateUserFinished = withAuthContext(DeactivateUserFinishedComponent);
export { DeactivateUserFinished };
